import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  overflow-y: hidden;
  overflow-x: hidden;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: ${Colors.Color2};
  color: ${Colors.Color3};

  .button-menu {
    background: ${Colors.Color1};
    display: flex;
    align-items: center;

    @media (max-width: 993px) {
      .identificacao {
        display: flex !important;
      }
    }
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: calc(100% - 3.9375rem - var(--aviso-novo-portal-altura, 0px));
    width: 100%;
  }

  .body-mobile {
    display: flex;
    flex-direction: column;
    height: calc(100% - var(--aviso-novo-portal-altura, 0px));
  }
`;

export const TopMenu = styled.div`
  position: relative;
  flex-shrink: 0;
  height: 3.7625rem;
  width: 100%;
  z-index: 4;

  .fundo-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: ${Colors.Color2};
    width: 100%;
    height: 100%;
    padding: 0 1.5rem;

    .lateral-e {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .sec-logo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        // width: 14rem;

        .logo {
          width: 6.79rem;
        }
      }
    }

    .lateral-d {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 14rem;

      button {
        margin-right: 1.5rem;
      }
    }
  }

  .fundo-bottom {
    background: ${Colors.Color1};
    height: 2.7rem;
    width: 100%;
    border-bottom: 2px solid ${localStorage.getItem("tema") == "E" ? "#28242b" : Colors?.Color2};

    .navigation-menu {
      display: flex;
      width: 4rem;
      justify-content: center;
      align-items: center;
      height: 100%;
      flex-direction: row;

      .nav {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        img {
          width: 1.4rem;
          height: 1.6rem;
        }
      }
    }
  }
`;

export const ButtonMenu = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.3125rem;
  padding: 0;
  background: ${Colors.Color2};
  border: 0;

  img {
    width: 1.4rem;
  }
`;

export const Main = styled.div`
  display: flex;
  justify-content: center;
  z-index: 2;
  background: ${Colors.Color2};
  transition: 0.5s;
  padding: 0 0rem 1rem 0rem;

  ${({ showMenuRight, showSubMenu, showSubMenuRight }) => {
    if (showMenuRight) {
      if ((showSubMenu && showSubMenuRight == false) || (showSubMenu == false && showSubMenuRight)) {
        return `
          overflow: initial;
          width: calc(100% - 23.8rem);
        `;
      } else if (showSubMenu && showSubMenuRight) {
        return `
          width: calc(100% - 32rem);
          overflow: hidden;
        `;
      } else {
        return `
            width: calc(100% - 9rem);
            overflow: hidden;
          `;
      }
    } else {
      if (showSubMenu) {
        return `
          overflow: initial;
          width: calc(100% - 17rem);
        `;
      } else {
        return `
            width: calc(100% - 4.8rem);
            overflow: hidden;
          `;
      }
    }
  }}

  .mainScroll > div:last-child {
    bottom: 24px !important;
    top: 24px !important;
  }
`;

export const MainScroll = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
  height: auto;
  min-height: 100%;
  border-radius: 0.8125rem;
  background: ${Colors.Color13};
`;

export const LeftMenu = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  width: ${(props) => props.width};
  height: 100%;
  left: 0;
  z-index: 2;
  background: ${Colors.Color2};
  padding-bottom: 1rem;
`;